import React, { Suspense } from 'react';
import { render } from 'react-dom';
import { MemoryRouter as Router, Route, NavLink } from 'react-router-dom';
import {
    StateMachineProvider,
    createStore,
    setStorageType,
} from 'little-state-machine';

import './global.scss';
import { reactForm, title, active } from './style.module.scss';
import './Responsive.css';

setStorageType({
    setItem: () => { },
    getItem: () => {
        return { formData: {} };
    },
    ...localStorage,
});
createStore({ formData: {} });

const handleClick = (e) => {
    const { linkDisabled } = e.target.classList.value.length > 0;
    if (!linkDisabled) e.preventDefault()
}

export default function App() {
    return (
        <StateMachineProvider>
            <div className={`${reactForm} container`}>
                <h1 className={title}>Checkout</h1>
                <Router>
                    <nav>
                        <NavLink to="/" onClick={handleClick} exact activeClassName={active}>
                            1. Course Detail
                        </NavLink>
                        <NavLink to="/step-2" onClick={handleClick} activeClassName={active}>
                            2. Personal Information
                        </NavLink>
                        <NavLink to="/step-3" onClick={handleClick} activeClassName={active}>
                            3. Additional Information
                        </NavLink>
                        <NavLink to="/result" onClick={handleClick} activeClassName={active}>
                            4. Payment
                        </NavLink>
                    </nav>
                    <Suspense fallback={<div>Loading...</div>}>
                        <Route
                            exact
                            path="/"
                            component={React.lazy(() =>
                                import('./steps/Step1')
                            )}
                        />
                        <Route
                            path="/step-2"
                            component={React.lazy(() =>
                                import('./steps/Step2')
                            )}
                        />
                        <Route
                            path="/step-3"
                            component={React.lazy(() =>
                                import('./steps/Step3')
                            )}
                        />
                        <Route
                            path="/result"
                            component={React.lazy(() =>
                                import('./steps/Result')
                            )}
                        />
                    </Suspense>
                </Router>
            </div>
        </StateMachineProvider>
    );
}

render(<App />, document.getElementById('payment-form'));
